import { Component, OnInit, Renderer2, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ProductService } from 'src/app/_service/product.service';
import { AlertifyService } from 'src/app/_service/alertify.service';
import { FormControl, Validators, FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { CreateManufacturerComponent } from 'src/app/manufacturer/create-manufacturer/create-manufacturer.component';
import { MatDialog, MatCheckbox, MatTabChangeEvent } from '@angular/material';
import { ManufacturerService } from 'src/app/_service/manufacturer.service';
import { Whmis2015Service } from 'src/app/_service/whmis2015.service';
import { EditManufacturerComponent } from 'src/app/manufacturer/edit-manufacturer/edit-manufacturer.component';
import { ManufacturerServerSearchComponent } from 'src/app/manufacturerServerSearch/manufacturerServerSearch.component';
import { FileuploadComponent } from 'src/app/fileupload/fileupload.component';
import { TreeComponent } from 'src/app/tree/tree.component';
import { FileuploadService } from 'src/app/_service/fileupload.service';
import { AppCustomDirective } from 'src/app/_extensions/app.validators';
import { BrowserDetectorService } from 'src/app/_service/browserDetector.service';

@Component({
  selector: 'app-create-product',
  templateUrl: './create-product.component.html',
  styleUrls: ['./create-product.component.css']
})

export class CreateProductComponent implements OnInit {

  productCreationForm: FormGroup;
  pictogramFormGroup: FormGroup;
  @ViewChild(ManufacturerServerSearchComponent, { static: true }) manufacturerSearch: ManufacturerServerSearchComponent;
  @ViewChild(FileuploadComponent, { static: true }) filepdf: FileuploadComponent;
  @ViewChild(TreeComponent, { static: true }) locationTree: TreeComponent;

  DaterForm: FormGroup;

  constructor(private productService: ProductService,
    private alertify: AlertifyService,
    private dialog: MatDialog,
    private manufacturerService: ManufacturerService,
    private fileService: FileuploadService,
    private whmis2015Service: Whmis2015Service,
    public fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
    public detectBrowser: BrowserDetectorService
) {
  this.DaterForm = this.fb.group(
    {
      FromDate: ['', [AppCustomDirective.fromDateValidator]]
    });

  this.productCreationForm = fb.group({
    productNameFormControl : new FormControl('', [
      Validators.required,
      this.WhitespaceValidator
    ]),
    productAliasControl : new FormControl('', []).clearValidators(),
    productCodeFormControl : new FormControl('', []).clearValidators(),
    // manufacturerFormControl : new FormControl('', [
    //   Validators.required,
    // ]),
    additionalSuppliersFormControl : new FormControl('', []).clearValidators(),

    revisionDateFormControl : new FormControl('', []).clearValidators(),

    lastVerifiedFormControl : new FormControl('', []).clearValidators(),

    mostRecentRequestFormControl: new FormControl('', []).clearValidators(),

    registrationFormControl : new FormControl('', []).clearValidators(),
    sdsOriginFormControl : new FormControl('', []).clearValidators(),
    exemptionClassFormControl : new FormControl('', []).clearValidators(),
    sdsFormatFormControl : new FormControl('', []).clearValidators(),
    whmisExemptFormControl : new FormControl('', []).clearValidators(),
    discontinuedFormControl : new FormControl('', []).clearValidators(),

    sdsAvailabilityFormControl : new FormControl('', []).clearValidators(),
    sdsHazardIdentificationFormControl : new FormControl('', []).clearValidators(),
    notesFormControl : new FormControl('', []).clearValidators(),

    hazardCategoryFormControl : new FormControl('', []).clearValidators(),

    hmisHealthRatingFormControl : new FormControl('', []).clearValidators(),

    hmisChronicRatingFormControl : new FormControl('', []).clearValidators(),

    hmisFlammabilityRatingFormControl : new FormControl('', []).clearValidators(),
    hmisReactivityFormControl: new FormControl('', []).clearValidators(),

    nfpaHealthRatingsFormControl: new FormControl('', []).clearValidators(),
    nfpaInstabilityFormControl: new FormControl('', []).clearValidators(),
    nfpaSpecificFormControl: new FormControl('', []).clearValidators(),
    nfpaFlammabilityFormControl: new FormControl('', []).clearValidators(),
    iarcFormControl: new FormControl('', []).clearValidators(),
    acgihFormControl: new FormControl('', []).clearValidators(),

    transportHazardClassFormControl: new FormControl('', []).clearValidators(),

    physicalStateFormControl: new FormControl('', []).clearValidators(),

    physicalHazardClassFormControl: new FormControl('', []).clearValidators(),

    healthHazardFormControl: new FormControl('', []).clearValidators(),
    acuteToxicityRouteFormControl: new FormControl('', []).clearValidators(),
    skinCorrosionRouteFormControl: new FormControl('', []).clearValidators()
});
  this.pictogramFormGroup = this.fb.group({
    pictograms: this.fb.array([])
  });
 }

 creationmodel: any = {};
 isModified = false;
 goToLocationTab: any;

  // creationmodel: CreateProductModel;

  model: any = {};
  product: any = {};
  acuteRoutes: any = [];
  skinRoutes: any = [];
  physRoutes: any = [];
  routesArray: number;
  physicalRoutesArray: number;
  pictograms: any = [];
  pictogramArray: number;
  MSDSOriginArray: number;
  MSDSFormatArray: number;
  selected: number;
  selectedHealthRoutes: number;
  selectedMSDSOrigin: any = [];
  selectedMSDSFormat: number;
  selectedExemptionClass: number;
  selectedStatus: number;
  selectedSkinCorrosionIrritation: any;
  ExemptionClassFormatArray: number;
  StatusFormatArray: number;
  MSDSFormatModel: string;

  selectedManufacturerId: any;

  route;
  routeChecked = false;

  selectedIndex: number = 0;

  productModel: any;
  anotherTest: any;

  confirmModal = false;

  AcuteToxicityRoute: any = [];
  SkinCorrosionIrritationRoute: any = [];

  Discontinued: string;
  discontinued: any;

  disableIcon = false;

  imageBind: any = [];
  pictogramValue: any = [];
  selectedCheckBoxes: any = [];

  sdsAvailabilityChecked: any;
  sdsHazardIdentification: any;

  ProductName: any;

  fileExistsCheck: any;
  createdProductId: any;

  manufacturerValue: any;

  revisionDate: string;
  lastVerifiedDate: string;
  mostRecentRequest: string;

  revisionFC: any;
  lastVerifiedDateFC: any;
  mostRecentRequestFC: any;

  show = false;
  isDateValid = false;

  MSDSOriginGroups: MSDSOriginGroup[] = [
    {
      name: 'SDS Origin',
      origin: [
        {value: 0, viewValue: 'Not Available'},
        {value: 1, viewValue: 'Canada'},
        {value: 2, viewValue: 'USA'},
        {value: 3, viewValue: 'Europe'},
        {value: 4, viewValue: 'Other'}
      ]
    },
  ];

  formatValue: string;
  sdsFormat: SDSFormat[] = [
    {value: '1', viewValue: 'GHS'},
    {value: '2', viewValue: 'Other'}
  ];

  exemptValue: string;
  whmisExempt: WhmisExempt[] = [
    {value: '0', viewValue: 'No'},
    {value: '1', viewValue: 'Yes'}
  ];

  discontinuedValue: string;
  discontinuedObj: Discontinued[] = [
    {value: '0', viewValue: 'No'},
    {value: '1', viewValue: 'Yes'}
  ];


  sdsFormatValue: string;
  MSDSFormatFormControl = new FormControl();
  MSDSFormatGroups: SDSFormatGroup[] = [
    {
      name: 'SDS Format',
      format: [
        {value: '1', viewValue: 'GHS'},
        {value: '2', viewValue: 'Other'}
      ]
    },
  ];

  ExemptionClassFormControl = new FormControl();
  ExemptionClassGroups: ExemptionClassFormatGroup[] = [
    {
      name: 'Exemption Class',
      exemptionClass: [
        {value: '1', viewValue: 'Nonhazardous'},
        {value: '2', viewValue: 'Cosmetic, device, drug or food'},
        {value: '3', viewValue: 'Pest control product'},
        {value: '4', viewValue: 'Consumer product'},
        {value: '5', viewValue: 'Manufactured article'},
        {value: '6', viewValue: 'Nuclear substance'},
        {value: '7', viewValue: 'Explosive'}
      ]
    },
  ];

  StatusFormControl = new FormControl();
  StatusGroups: StatusFormatGroup[] = [
    {
      name: 'Status',
      status: [
        {value: '1', viewValue: 'No MSDS Available'}, 
        {value: '2', viewValue: 'Unable to identity hazards'},
      ]
    },
  ];

  AcuteToxicityControl = new FormControl();
  AcuteToxicityGroups: AcuteToxicityGroup[] = [
    {
      name: 'Acute toxity Route',
      status: [
        {value: '1', viewValue: 'Oral'},
        {value: '2', viewValue: 'Dermal'},
        {value: '3', viewValue: 'Inhalation'},
        {value: '4', viewValue: 'Unspecified'},
      ]
    },
  ];

  SkinCorrosionIrritationControl = new FormControl();
  SkinCorrosionIrritationGroups: SkinCorrosionIrritationGroup[] = [
    {
      name: 'Skin corrosion / irritation Route',
      status: [
        {value: '1', viewValue: 'Skin'},
        {value: '2', viewValue: 'Eye'},
        {value: '3', viewValue: 'Respiratory'},
        {value: '4', viewValue: 'Ingestion'},
        {value: '3', viewValue: 'Unspecified'},
      ]
    },
  ];

  public WhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }


  ngOnInit() {
    this.detectBrowser.DetectIE();
    this.manufacturerDropDown();
    this.pictogramReferences();
    this.healthClassDropDown();
    this.physicalClassDropDown();
    this.AcutehealthRoutes();
    this.SkinHealthRoutes();
    this.getCategoryDropDown();
    this.getHmisRatingshealthDropDown();
    this.getHmisRatingsChronicDropDown();
    this.getHmisRatingsFlammabilityDropDown();
    this.getHmisRatingsReactivityDropDown();
    this.getNfpaRatingsHealthDropDown();
    this.getNfpaRatingsInstabilityDropDown();
    this.getNfpaRatingsSpecificDropDown();
    this.getNfparatingsFlammabilityDropDown();
    this.getIArcDropDown();
    this.getAcgihDropDown();
    this.getTransportHazardDropDown();
    this.getPhysicalStatesDropDown();
    this.getExemptionClassDropDown();
    this.getSDSOriginDropDown();
    this.sdsFormatValue = '1';
    this.exemptValue = '0';
    this.discontinuedValue = '0';

    this.revisionFC = this.productCreationForm.get('revisionDateFormControl');
    this.lastVerifiedDateFC = this.productCreationForm.get('lastVerifiedFormControl');
    this.mostRecentRequestFC = this.productCreationForm.get('mostRecentRequestFormControl');
    this.checkDateCondition(true);

    this.revisionFC.markAsTouched();
    this.lastVerifiedDateFC.markAsTouched();
    this.mostRecentRequestFC.markAsTouched();
  }

  ngAfterViewChecked() {
    const show = this.validateFormControl(this.productCreationForm);
    if (show != this.show) {
      this.show = show;
      this.cdr.detectChanges();
    }
    this.productCreationForm.get('lastVerifiedFormControl').value;
    this.cdr.detectChanges();
  }

  public validateFormControl(control) {
    if (this.manufacturerValue !== undefined) {
      if (control.status === 'VALID' && this.manufacturerValue.status === 'VALID' && this.selectedManufacturerId) {
        return true;
      } else {
        return false;
      }
    }
  }

  checkDateCondition(flg = false) {
    const p1 = Date.parse((new Date(this.revisionDate)).toLocaleString('en-US', {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric'
    }).replace(/[^ -~]/g,''));
    const p2 = Date.parse((new Date(this.lastVerifiedDate)).toLocaleString('en-US', {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric'
    }).replace(/[^ -~]/g,''));
    const result = this.revisionDate != null && this.lastVerifiedDate != null && !isNaN(p1) && !isNaN(p2) && p1 > p2;
    if (result) {
      this.lastVerifiedDateFC.setErrors({ checkDateCondition: true });
    } else {
      this.lastVerifiedDateFC.setErrors({ checkDateCondition: null });
      this.lastVerifiedDateFC.updateValueAndValidity();
    }
  }

  changeRevisionDate(event) {
    this.revisionDate = event.target.value;
    this.checkDateCondition();
  }

  changeLastVerifiedDate(event) {
    this.lastVerifiedDate = event.target.value;
    this.checkDateCondition();
  }

  changeMostRecentRequestDate(event) {
    this.mostRecentRequest = event.target.value;
    this.checkDateCondition();
  }

  dateReturnErrorMessage() {
    if (this.lastVerifiedDateFC.hasError('checkDateCondition')) {
      return 'Last verified must be equal or greater than the Revision date';
    } else {
      return 'Please enter a valid date';
    }
  }

  locationValidator(locationTreeId) {
    if (locationTreeId !== undefined) {
      for (const locationId of locationTreeId.checklistSelection._selection) {
        if (locationId.authorityUnitId !== undefined) {
          return true;
        } else {
          return false;
        }
      }
    }
  }

  manufacturerValidator(validate) {
    this.manufacturerValue = validate.bankServerSideCtrl;
  }

  onSDSAvailabilityChecked($event) {
    console.log($event.checked);
    if ($event.checked) {
      this.sdsAvailabilityChecked = 1;
    } else {
      this.sdsAvailabilityChecked = 0;
    }
  }

  hazardIdentification($event) {
    console.log($event.checked);
    if ($event.checked) {
      return this.sdsHazardIdentification = 1;
    } else {
      this.sdsHazardIdentification = 0;
    }
  }

  selectedProductName($event) {
    this.ProductName = $event.target.value;
  }

  pictogramReferences() {
    return this.whmis2015Service.getPictograms().subscribe(res => {
      this.pictograms = res;
    });
  }

  checkedBoxes(id) {
    return (this.imageBind.find(x => x == id) == null) ? 'grayscale(100%)' : 'none';
  }

  onChangePictogram($event) {
    const pictograms = <FormArray>this.pictogramFormGroup.get('pictograms') as FormArray;
    this.pictogramValue = pictograms;
    this.selectedCheckBoxes = $event.source.value;
    if ($event.checked) {
      pictograms.push(new FormControl($event.source.value));
    } else {
      const i = pictograms.controls.findIndex(x => x.value === $event.source.value);
      pictograms.removeAt(i);
    }
    this.imageBind = pictograms.value;
  }


  // Delete products
  dontDeleteProduct() {
    this.confirmModal = false;
  }

  removeProduct() {
    this.confirmModal = false;
    this.dialog.closeAll();
  }

  clearProductWizard() {
    this.confirmModal = true;
  }

  onSelectStatus(selectedStatus) {
    var total = 0;
    for (const i of selectedStatus) {
      // the + impliys converting the string to a number
      total = +total + +selectedStatus[i];
      this.StatusFormatArray = total;
    }
    console.log(this.StatusFormatArray);
    this.model.statusFlag = this.StatusFormatArray;
  }
  selectedAcuteToxicityRoute: any = [];

  onSelectAcuteToxicityRoute(selectedAcuteToxicityRoute) {
    this.AcuteToxicityRoute = selectedAcuteToxicityRoute;
    console.log(selectedAcuteToxicityRoute);
    console.log(this.AcuteToxicityGroups);
    console.log(this.AcuteToxicityControl);
    console.log(this.AcuteToxicityControl.value);

    // console.log(this.AcuteToxicityControl.reset());
    // this.AcuteToxicityControl.value.clearValidators();
  }

  onSelectSkinCorrosionIrritation(selectedSkinCorrosionIrritation) {
    this.SkinCorrosionIrritationRoute = selectedSkinCorrosionIrritation;
    console.log(selectedSkinCorrosionIrritation);
  }

  onSelectExemptionClass(selectedExemptionClass) {
    var total = 0;
    for (const i of selectedExemptionClass) {
      // the + impliys converting the string to a number
      total = +total + +selectedExemptionClass[i];
      this.ExemptionClassFormatArray = total;
    }
    console.log(this.ExemptionClassFormatArray);
    this.model.exemptionClassFlag = this.ExemptionClassFormatArray;
  }

  onSelectMSDSFormat(selectedMSDSFormat) {
    var total = 0;
    for(const i of selectedMSDSFormat){
      // the + impliys converting the string to a number
      total = +total + +selectedMSDSFormat[i];
      this.MSDSFormatArray = total;
    }
    console.log(this.MSDSFormatArray);
    this.model.formatId = this.MSDSFormatArray;
  }

   onSelectMSDSOrigin(selectedMSDSOrigin) {
    var total = 0;
    for(const i of selectedMSDSOrigin){
      // the + impliys converting the string to a number
      total = +total + +selectedMSDSOrigin[i];
      this.MSDSOriginArray = total;
    }
    console.log('thismsdsoriginarry :' + this.MSDSOriginArray);
    this.model.originFlag = this.MSDSOriginArray;
  }

  openManufacturerEditPage(id) {
    console.log(id);
      const dialogRef = this.dialog.open(EditManufacturerComponent, {
        width: '1000px',
        data: {
          manufacturerId: id,
          // selectedManu: this.selectedMan,
          serverSideSearch: this.manufacturerSearch
        }
      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        // returns true or false
        if (dialogRef.componentInstance.isModified) {
          this.manufacturerDropDown();
        }
      });
  }

  // openManufacturerEditPage(id) {
  //   console.log(id);
  //     const dialogRef = this.dialog.open(EditManufacturerComponent, {
  //       width: '500px',
  //       data: {
  //         manufacturerId: id,
  //         // selectedManu: this.selectedMan,
  //         selectedManu: this.manufacturerSearch
  //       }
  //     });
  //     dialogRef.disableClose = true;
  //     dialogRef.afterClosed().subscribe(result => {
  //       // returns true or false
  //       if (dialogRef.componentInstance.isModified) {
  //         this.manufacturerDropDown();
  //       }
  //     });
  // }
  
  openManufacturerCreatePage() {
    const dialogRef = this.dialog.open(CreateManufacturerComponent, {
      width: '1000px'
    });
    const subscribeDialog = dialogRef.componentInstance.setManufacturer.subscribe((data) => {
      this.manufacturerSearch.bankServerSideCtrl.setValue(data.body);
      this.manufacturerSearch.placeholder = data.body.name;
    });
    dialogRef.afterClosed().subscribe(result => {
      subscribeDialog.unsubscribe();
      this.manufacturerDropDown();
      dialogRef.disableClose = true;
    });
  }

  file_upload: any;

  handleFileInput($event) {
    console.log($event);
    for (const file of $event) {
      console.log(file.type);
    }
  }


addfield()  {
  console.log('function triggered');
  const div = this.renderer.createElement('div');
  const input = this.renderer.createElement('input');

  this.renderer.appendChild(div, input);

  this.renderer.addClass(div, 'col-md-6');
  this.renderer.addClass(div, 'col-sm-6');
  this.renderer.addClass(div, 'col-xs-12');

  console.log('cross passes the code');
  this.renderer.addClass(input, 'form-control');
  this.renderer.addClass(input, 'col-md-7');
  this.renderer.addClass(input, 'col-xs-12');

  const textboxes = document.getElementById('textboxes');

  this.renderer.appendChild(textboxes, div);
}

propagateChange = (_: any) => { };
selectedFileName: string = null;

changeListener($event): void {
  // debugger; // uncomment this for debugging purposes
  this.readThis($event.target);
  console.log($event);
}
readThis(inputValue: any): void {
  // debugger; // uncomment this for debugging purposes
  var file: File = inputValue.files[0];
  var myReader: FileReader = new FileReader();

  myReader.onloadend = (e) => {
      this.propagateChange(myReader.result);
      this.selectedFileName = file.name;
  }
  myReader.readAsDataURL(file);
}

  manufacturerDropDown() {
    this.manufacturerSearch.bankServerSideCtrl.valueChanges.subscribe(() => {
        // tslint:disable-next-line: max-line-length
        if (this.manufacturerSearch.bankServerSideCtrl.value.manufacturerId !== undefined) {
          this.selectedManufacturerId = this.manufacturerSearch.bankServerSideCtrl.value == null ? null :
          this.manufacturerSearch.bankServerSideCtrl.value.manufacturerId;
        } else {
         this.selectedManufacturerId = this.manufacturerSearch.bankServerSideCtrl.value == null ? null :
         this.manufacturerSearch.bankServerSideCtrl.value;
        }

        if (this.selectedManufacturerId) {
          this.disableIcon = true;
        } else {
          this.disableIcon = false;
        }
    });
  }

  // healthHazardClassList = new FormControl('', [Validators.required]);
  healths;
  selectedHealthClass;
  healthClassList: any = [];
  physicalClassList: number;

  acuteToxicity: any;
  skinCorrosionIrritation: any;

  onSelectedHealthHazardClass(selectedHealthClass) {
    const acuteToxValResponse = this.healths.find(x => x.healthClassName == 'Acute toxicity');
    const skinCorvalResponse = this.healths.find(x => x.healthClassName == 'Skin corrosion/irritation');
    this.acuteToxicity = false;
    this.skinCorrosionIrritation = false;
    console.log(selectedHealthClass);
    for (const selectedValue of selectedHealthClass) {
      console.log(selectedValue.healthClassId);
      if (selectedValue.healthClassName === acuteToxValResponse.healthClassName) {
        this.acuteToxicity = true;
      }
      if (selectedValue.healthClassName === skinCorvalResponse.healthClassName) {
        this.skinCorrosionIrritation = true;
      }
    }
    const selectedAcuteTox = selectedHealthClass.find(x => x.healthClassName == acuteToxValResponse.healthClassName && x.length !== 0);

    if (selectedAcuteTox === undefined) {
      this.productCreationForm.get('acuteToxicityRouteFormControl').reset();
    }

    const selectedSkinIrr  = selectedHealthClass.find(x => x.healthClassName == skinCorvalResponse.healthClassName && x.length !== 0);

    if (selectedSkinIrr === undefined) {
      this.productCreationForm.get('skinCorrosionRouteFormControl').reset();
    }
  }

  healthClassDropDown() {
      return this.whmis2015Service.getHealthClass().subscribe(res => {
        this.healths = res;
    });
  }

  physicals: any;
  selectedPhysicalClass: any = [];

  onSelectedPhysicalHazardClass(selectedPhysicalClass) {
    console.log(selectedPhysicalClass);
  }

  physicalClassDropDown() {
    return this.whmis2015Service.getPhysicalClass().subscribe(res => {
      this.physicals = res;
  });
  }


  AcutehealthRoutes() {
    return this.whmis2015Service.getAcuteHealthRoutes().subscribe(res => {
      this.acuteRoutes = res;
    });
  }

  onSelectHealthRoutes(checkbox: MatCheckbox, model: {healthRouteId: number}){
      this.model.healthRouteId = model.healthRouteId;
      this.routesArray = model.healthRouteId;
  }

  SkinHealthRoutes() {
    return this.whmis2015Service.getSkinIrrCorrHealthRoutes().subscribe(res => {
      this.skinRoutes = res;
    });
  }

  // pictogramReferences() {
  //   return this.whmis2015Service.getPictograms().subscribe(res => {
  //     this.pictograms = res;
  //   });
  // }

  // onSelectedPictograms(checkbox: MatCheckbox, model: {pictogramId: number}) {
  //   this.model.pictogramId = model.pictogramId;
  //   this.pictogramArray = model.pictogramId;
  // }

  physicalRoutes() {
    return this.whmis2015Service.getPhysicalRoutes().subscribe(res => {
      this.physRoutes = res;
    });
  }

  onSelectPhysicalRoutes(checkbox: MatCheckbox, model: {physicalRouteId: number}){
      this.model.physicalRouteId = model.physicalRouteId;
      this.physicalRoutesArray = model.physicalRouteId;
  }

  searchTerm: FormControl = new FormControl();
  myList: number;

  manufacturerList = new FormControl('', [Validators.required]);
  manufacturers;
  manufacturerArray;
  selectedManufacturer: any;
  // selected;

  onSelectManufacturers(selected) {
      this.selectedManufacturer = selected;
      console.log(selected);
  }

  physicalStates: any;
  selectedPhysicalStates: any = [];

  getPhysicalStatesDropDown() {
    return this.whmis2015Service.getPhysicalStates().subscribe(res => {
      this.physicalStates = res;
      this.selectedPhysicalStates = this.physicalStates.slice(0, 1);
    });
  }

  onSelectedPhysicalStates(selectedPhysicalStates) {
    console.log(selectedPhysicalStates);
    this.selectedPhysicalStates = selectedPhysicalStates;
  }

  clickPhysicalState(physicalState) {
    if (physicalState.physicalStateId === 19) {
      this.selectedPhysicalStates = this.physicalStates.slice(0, 1);
    } else if (physicalState.physicalStateId === 28) {
      this.selectedPhysicalStates = this.physicalStates.slice(9, 10);
    } else {
      this.selectedPhysicalStates = this.selectedPhysicalStates.filter(x => x.physicalStateId !== 19 && x.physicalStateId !== 28);
    }
  }

  exemptionClass: any;
  
  getExemptionClassDropDown() {
    return this.whmis2015Service.getExemptionClass().subscribe(res => {
      this.exemptionClass = res;
    });
  }

  onSelectedExemptionClass(selectedExemptionClass) {
    console.log(selectedExemptionClass);
  }

  selectedSDSOrigin: any;
  sdsOrigin: any;

  getSDSOriginDropDown() {
    return this.whmis2015Service.getSDSOrigin().subscribe(res => {
      this.sdsOrigin = res;
      // this.selectedSDSOrigin = this.sdsOrigin.slice(0, 1);
    });
  }

  onSelectedSDSOrigin(selectedSDSOrigin) {
    console.log(selectedSDSOrigin);
  }

categories: any;
categList: number;
categoriesList = new FormControl('', []);
selectedCategories: any = [];

getCategoryDropDown() {
  return this.whmis2015Service.getHazardCategory().subscribe(res => {
    this.categories = res;
});
}


onSelectedCategories(selectedCategories) {
  console.log(selectedCategories);
}

transportHazard: any;
selectedTransportHazard: any = [];

getTransportHazardDropDown() {
  return this.whmis2015Service.getTransportHazardClasses().subscribe(res => {
    this.transportHazard = res;
    this.selectedTransportHazard = this.transportHazard.slice(21, 22);
});
}

onSelectedTransportHazardClasses(selectedTransportHazard) {
  console.log(selectedTransportHazard);
}


iarc: any;
selectedIarc: any = [];

getIArcDropDown() {
    return this.whmis2015Service.getAllIArcValues().subscribe(res => {
      this.iarc = res;
      this.selectedIarc = this.iarc.slice(0, 1);
  });
}

onSelectedIArc(selectedIarc) {
  console.log(selectedIarc);
}

acgih: any;
selectedacgih: any = [];

getAcgihDropDown() {
  return this.whmis2015Service.getAllAcgihValues().subscribe(res => {
    this.acgih = res;
    this.selectedacgih = this.acgih.slice(0, 1);
});
}

onSelectedAcgih(selectedacgih) {
  console.log(selectedacgih);
}

nfpaRatingsHealth;
selectednfpaRatingsHealth: any;

getNfpaRatingsHealthDropDown() {
  return this.whmis2015Service.getAllNFPARatingsHealthValues().subscribe(res => {
    this.nfpaRatingsHealth = res;
    this.selectednfpaRatingsHealth = this.nfpaRatingsHealth[0];
});
}

onSelectedNfpaRatingsHealth(selectednfpaRatingsHealth) {
  console.log(selectednfpaRatingsHealth);
}

nfparatingsFlammability;
selectednfparatingsFlammability: any;

getNfparatingsFlammabilityDropDown() {
  return this.whmis2015Service.getAllNfpaRatingsFlammabilityValues().subscribe(res => {
    this.nfparatingsFlammability = res;
    this.selectednfparatingsFlammability = this.nfparatingsFlammability[0];
});
}

onSelectedNfparatingsFlammability(selectednfparatingsFlammability) {
  console.log(selectednfparatingsFlammability);
}

nfpaRatingsInstability;
selectednfpaRatingsInstability: any;

getNfpaRatingsInstabilityDropDown() {
  return this.whmis2015Service.getAllNfpaRatingsInstability().subscribe(res => {
    this.nfpaRatingsInstability = res;
    this.selectednfpaRatingsInstability = this.nfpaRatingsInstability[0];
});
}

onSelectedNfpaRatingsInstability(selectednfpaRatingsInstability) {
  console.log(selectednfpaRatingsInstability);
}

// nfpaRatingsSpecificList = new FormControl('', [Validators.required]);
nfpaRatingsSpecific;
// nfpaRatingsSpecificListResult: number;
selectednfpaRatingsSpecific: any;

getNfpaRatingsSpecificDropDown() {
  return this.whmis2015Service.getAllNfpaRatingsSpecific().subscribe(res => {
    this.nfpaRatingsSpecific = res;
    this.selectednfpaRatingsSpecific = this.nfpaRatingsSpecific[0];
});
}

onSelectedNfpaRatingsSpecific(selectednfpaRatingsSpecific) {
  console.log(selectednfpaRatingsSpecific);
}

// hmisRatingshealthList = new FormControl('', [Validators.required]);
hmisRatingshealth: any = [];
// hmisRatingshealthListResult: number;
selectedhmisRatingshealth: any = [];

getHmisRatingshealthDropDown() {
  return this.whmis2015Service.getAllHmisRatingsHealth().subscribe(res => {
    this.hmisRatingshealth = res;
    this.selectedhmisRatingshealth = this.hmisRatingshealth[0];
});
}

onSelectedHmisRatingshealth(selectedhmisRatingshealth) {
  console.log(selectedhmisRatingshealth);
}

// hmisRatingsChronicList = new FormControl('', [Validators.required]);
hmisRatingsChronic: any = [];
// hmisRatingsChronicListResult: number;
selectedhmisRatingsChronic: any = [];

getHmisRatingsChronicDropDown() {
  return this.whmis2015Service.getAllHmisRatingsChronic().subscribe(res => {
    this.hmisRatingsChronic = res;
    this.selectedhmisRatingsChronic = this.hmisRatingsChronic[0];
});
}

onSelectedHmisRatingsChronic(selectedhmisRatingsChronic) {
  console.log(selectedhmisRatingsChronic);
}

// hmisRatingsFlammabilityList = new FormControl('', [Validators.required]);
hmisRatingsFlammability;
// hmisRatingsFlammabilityListResult: number;
selectedhmisRatingsFlammability;

getHmisRatingsFlammabilityDropDown() {
  return this.whmis2015Service.getAllHmisRatingsFlammability().subscribe(res => {
    this.hmisRatingsFlammability = res;
    this.selectedhmisRatingsFlammability = this.hmisRatingsFlammability[0];
});
}

onSelectedHmisRatingsFlammability(selectedhmisRatingsFlammability) {
  console.log(selectedhmisRatingsFlammability);
}

// hmisRatingsReactivityList = new FormControl('', [Validators.required]);
hmisRatingsReactivity;
// hmisRatingsReactivityListResult: number;
selectedhmisRatingsReactivity;

getHmisRatingsReactivityDropDown() {
  return this.whmis2015Service.getAllHmisRatingsReactivity().subscribe(res => {
    this.hmisRatingsReactivity = res;
    this.selectedhmisRatingsReactivity = this.hmisRatingsReactivity[0];
});
}

onSelectedHmisRatingsReactivity(selectedhmisRatingsReactivity) {
  console.log(selectedhmisRatingsReactivity);
}

removeFields() {
  this.productCreationForm.controls.productNameFormControl.reset();
  this.productCreationForm.get('productNameFormControl').clearValidators();
  this.productCreationForm.controls.productNameFormControl.clearValidators();
  this.productCreationForm.controls.productAliasControl.reset();
  this.productCreationForm.controls.productCodeFormControl.reset();
  this.productCreationForm.controls.additionalSuppliersFormControl.reset();
  this.productCreationForm.controls.revisionDateFormControl.reset();
  this.productCreationForm.controls.lastVerifiedFormControl.reset();
  this.productCreationForm.controls.mostRecentRequestFormControl.reset();
  this.productCreationForm.controls.registrationFormControl.reset();
  this.productCreationForm.controls.sdsOriginFormControl.reset();
  this.productCreationForm.controls.exemptionClassFormControl.reset();

  this.sdsFormatValue = '1';
  this.exemptValue = '0';
  this.discontinuedValue = '0';

  this.manufacturerSearch.manufacturer = [];
  this.selectedManufacturerId = null;

  let formData = new FormData();
  if (this.filepdf.files.length > 0) {
    this.filepdf.files = [];
    this.creationmodel.FileName = null;
    this.filepdf.checkedTime = 0;
    formData = null;
  }

  this.productCreationForm.controls.sdsAvailabilityFormControl.reset();
  this.productCreationForm.controls.sdsHazardIdentificationFormControl.reset();
  this.productCreationForm.controls.notesFormControl.reset();
  this.imageBind = [];

  this.selectedCategories = [];
  this.selectedhmisRatingshealth = this.hmisRatingshealth[0];
  this.selectedhmisRatingsChronic = this.hmisRatingsChronic[0];
  this.selectedhmisRatingsFlammability = this.hmisRatingsFlammability[0];
  this.selectedhmisRatingsReactivity = this.hmisRatingsReactivity[0];

  this.selectedIarc = this.iarc.slice(0, 1);
  this.selectedacgih = this.acgih.slice(0, 1);
  this.selectednfpaRatingsHealth = this.nfpaRatingsHealth[0];
  this.selectednfparatingsFlammability = this.nfparatingsFlammability[0];
  this.selectednfpaRatingsInstability = this.nfpaRatingsInstability[0];
  this.selectednfpaRatingsSpecific = this.nfpaRatingsSpecific[0];
  this.selectedTransportHazard = this.transportHazard.slice(21, 22);

  this.selectedPhysicalStates = this.physicalStates.slice(0, 1);
  this.productCreationForm.controls.physicalHazardClassFormControl.reset();
  this.productCreationForm.controls.healthHazardFormControl.reset();

  this.productCreationForm.controls.acuteToxicityRouteFormControl.reset();
  this.productCreationForm.controls.skinCorrosionRouteFormControl.reset();
  this.acuteToxicity = false;
  this.skinCorrosionIrritation = false;

  this.locationTree.checklistSelection.clear();
  this.returnToIntialTab();
}

moveToSelectedTab(tabName: string) {
  for (let i = 0; i < document.querySelectorAll('.mat-tab-label-content').length; i++) {
      if ((<HTMLElement>document.querySelectorAll('.mat-tab-label-content')[i]).innerText == tabName) {
        (<HTMLElement>document.querySelectorAll('.mat-tab-label')[i]).click();
      }
    }
}

returnToIntialTab() {
  for (let i = 0; i < document.querySelectorAll('.mat-tab-label-content').length; i++) {
    if ((<HTMLElement>document.querySelectorAll('.mat-tab-label-content')[i]).innerText == 'Product info') {
      (<HTMLElement>document.querySelectorAll('.mat-tab-label')[i]).click();
    }
  }}

tabChanged(tabChangeEvent: MatTabChangeEvent) {
    this.goToLocationTab = tabChangeEvent.index;
}

moveToLocationTab() {
  if (this.goToLocationTab == 3) {
    for (let i = 0; i < document.querySelectorAll('.mat-tab-label-content').length; i++) {
        (<HTMLElement>document.querySelectorAll('.mat-tab-label')[i]).click();
    }
  }
}

 createProductInformation() {
  console.log(this.productCreationForm.controls);

    this.creationmodel.ProductName = this.productCreationForm.get('productNameFormControl').value.trim();
    this.creationmodel.ProductAlias = this.productCreationForm.get('productAliasControl').value == null ? null :
    this.productCreationForm.get('productAliasControl').value.trim();
    this.creationmodel.ProductCode = this.productCreationForm.get('productCodeFormControl').value == null ? null :
    this.productCreationForm.get('productCodeFormControl').value.trim();
    this.creationmodel.ManufacturerId = this.selectedManufacturerId;
    this.creationmodel.AdditionalSuppliers = this.productCreationForm.get('additionalSuppliersFormControl').value == null ? null :
    this.productCreationForm.get('additionalSuppliersFormControl').value.trim();

    this.creationmodel.LastVerified = this.lastVerifiedDate;
    this.creationmodel.RevisionDate = this.revisionDate;
    this.creationmodel.MostRecentRequestDate = this.productCreationForm.get('mostRecentRequestFormControl').value;

    this.creationmodel.RegistrationNumber = this.productCreationForm.get('registrationFormControl').value == null ? null :
    this.productCreationForm.get('registrationFormControl').value.trim();
    this.creationmodel.SDSOrigin = this.productCreationForm.get('sdsOriginFormControl').value == null ? null :
    this.productCreationForm.get('sdsOriginFormControl').value.map(({ sdsoriginId }) => sdsoriginId);
    this.creationmodel.ExemptionClass =
    this.productCreationForm.get('exemptionClassFormControl').value == null ? null :
    (this.productCreationForm.get('exemptionClassFormControl').value.map(({ exemptionClassId }) => exemptionClassId));
    this.creationmodel.SDSFormat = this.productCreationForm.get('sdsFormatFormControl').value;
    this.creationmodel.WHMISExempt = this.productCreationForm.get('whmisExemptFormControl').value == '0' ? (0) : (1);
    this.creationmodel.Discontinued = this.productCreationForm.get('discontinuedFormControl').value == '0' ? (0) : (1);
    this.creationmodel.SDSAvailability = this.productCreationForm.get('sdsAvailabilityFormControl').value == true ? (1) : (0);
    this.creationmodel.sdsHazardIdentification = 
    this.productCreationForm.get('sdsHazardIdentificationFormControl').value == true ? (1) : (0);
    this.creationmodel.Pictogram = this.imageBind;
    this.creationmodel.Notes = this.productCreationForm.get('notesFormControl').value == null ? null :
    this.productCreationForm.get('notesFormControl').value.trim();
    this.creationmodel.HazardCategoryId = this.productCreationForm.get('hazardCategoryFormControl').value == null ? null :
    this.productCreationForm.get('hazardCategoryFormControl').value.map(({ hazardCategoryId }) => hazardCategoryId);

    this.creationmodel.HMISHealthRatings =
    this.productCreationForm.get('hmisHealthRatingFormControl').value.hmisratingsHealthId;
    this.creationmodel.HMISChronicRatings =
    this.productCreationForm.get('hmisChronicRatingFormControl').value.hmisratingsChronicId;
    this.creationmodel.HMISFlammabilityRatings =
    this.productCreationForm.get('hmisFlammabilityRatingFormControl').value.hmisratingsFlammabilityId;
    this.creationmodel.HMISReactivityRatings =
    this.productCreationForm.get('hmisReactivityFormControl').value.hmisratingsReactivityId;
    this.creationmodel.NFPAHealthRatings =
     this.productCreationForm.get('nfpaHealthRatingsFormControl').value.nfparatingsHealthId;
    this.creationmodel.NFPAInstabilityRatings =
    this.productCreationForm.get('nfpaInstabilityFormControl').value.nfparatingsInstabilityId;
    this.creationmodel.NFPASpecificRatings =
     this.productCreationForm.get('nfpaSpecificFormControl').value.nfparatingsSpecificId;
    this.creationmodel.NFPAFlammabilityRatings =
     this.productCreationForm.get('nfpaFlammabilityFormControl').value.nfparatingsFlammabilityId;
    this.creationmodel.IARC = this.productCreationForm.get('iarcFormControl').value == null ? null :
     this.productCreationForm.get('iarcFormControl').value.map(({ iarcid }) => iarcid);
    this.creationmodel.ACGIH = this.productCreationForm.get('acgihFormControl').value == null ? null :
     this.productCreationForm.get('acgihFormControl').value.map(({ acgihid }) => acgihid);
    this.creationmodel.TransportHazardClass = this.productCreationForm.get('transportHazardClassFormControl').value == null ? null :
    this.productCreationForm.get('transportHazardClassFormControl').value.map(({ transportHazardId }) => transportHazardId);
    this.creationmodel.PhysicalState = this.productCreationForm.get('physicalStateFormControl').value == null ? null :
     this.productCreationForm.get('physicalStateFormControl').value.map(({ physicalStateId }) => physicalStateId);
    this.creationmodel.PhysicalHazardClass =
    this.productCreationForm.get('physicalHazardClassFormControl').value == null ? null :
     (this.productCreationForm.get('physicalHazardClassFormControl').value.map(({ physicalClassId }) => physicalClassId));
    this.creationmodel.HealthHazardClass =
    this.productCreationForm.get('healthHazardFormControl').value == null ? null :
     (this.productCreationForm.get('healthHazardFormControl').value.map(({ healthClassId }) => healthClassId));
    this.creationmodel.AcuteToxRoute = 
    this.productCreationForm.get('acuteToxicityRouteFormControl').value == null ? null :
     (this.productCreationForm.get('acuteToxicityRouteFormControl').value);
    this.creationmodel.SkinIrrCorrRoute =
    this.productCreationForm.get('skinCorrosionRouteFormControl').value == null ? null :
     (this.productCreationForm.get('skinCorrosionRouteFormControl').value);
    this.creationmodel.LocationId = [];
    for (const loc of this.locationTree.checklistSelection.selected) {
      this.creationmodel.LocationId.push(loc.authorityUnitId);
    }
    let formData = new FormData();
    if (this.filepdf.files.length === 0) {
      this.creationmodel.FileName = null;
      formData = null;
    } else {
      this.creationmodel.FileName = this.filepdf.files[0].name;
      formData.append(this.filepdf.files[0].name, this.filepdf.files[0]);
    }
console.log(this.creationmodel);
  return this.productService.createProduct(this.creationmodel).subscribe(res => {

    this.fileExistsCheck = res.headers.get('fileCheck');
    if (this.fileExistsCheck) {
      this.alertify.error(this.fileExistsCheck);
    } else {
      this.createdProductId = res.headers.get('productId');
      const productId = +this.createdProductId;
      if (this.filepdf.checkedTime > 0) {
        this.fileService.UploadFile(productId, formData);
      }
      this.isModified = true;
      // this.dialog.closeAll();
      this.removeFields();
      this.alertify.success('New product has been created successfully');
    }
  }, error => {
    this.alertify.error('Something went wrong, please try again');
  }
  );
  }

  
}

export interface StatusFormat {
  value: string;
  viewValue: string;
}

export interface StatusFormatGroup {
  disabled?: boolean;
  name: string;
  status: StatusFormat[];
}

export interface ExemptionClassFormat {
  value: string;
  viewValue: string;
}

export interface ExemptionClassFormatGroup {
  disabled?: boolean;
  name: string;
  exemptionClass: ExemptionClassFormat[];
}

export interface MSDSFormat {
  value: string;
  viewValue: string;
}

export interface SDSFormatGroup {
  disabled?: boolean;
  name: string;
  format: MSDSFormat[];
}

export interface MSDSOrigin {
  value: number;
  viewValue: string;
}

export interface MSDSOriginGroup {
  disabled?: boolean;
  name: string;
  origin: MSDSOrigin[];
}

export interface HealthHazard {
  value: string;
  viewValue: string;
}

export interface HealthHazardGroup {
  disabled?: boolean;
  name: string;
  hazard: HealthHazard[];
}

export interface PhysicalHazard {
  value: string;
  viewValue: string;
}

export interface PhysicalHazardGroup {
  disabled?: boolean;
  name: string;
  hazard: PhysicalHazard[];
}

export interface WhmisHazardCategory {
  value: string;
  viewValue: string;
}

export interface WhmisHazardCategoryGroup {
  disabled?: boolean;
  name: string;
  hazard: WhmisHazardCategory[];
}

export interface ACGIHCategory {
  value: string;
  viewValue: string;
}

export interface ACGIHGroup {
  disabled?: boolean;
  name: string;
  hazard: ACGIHCategory[];
}

export interface TransportHazardClassCategory {
  value: string;
  viewValue: string;
}

export interface TransportHazardClassGroup {
  disabled?: boolean;
  name: string;
  hazard: TransportHazardClassCategory[];
}

export interface SDSFormat {
  value: string;
  viewValue: string;
}

export interface WhmisExempt {
  value: string;
  viewValue: string;
}

export interface Discontinued {
  value: string;
  viewValue: string;
}

export interface AcuteToxicity {
  value: string;
  viewValue: string;
}

export interface AcuteToxicityGroup {
  disabled?: boolean;
  name: string;
  status: AcuteToxicity[];
}

export interface SkinCorrIrritation {
  value: string;
  viewValue: string;
}

export interface SkinCorrosionIrritationGroup {
  disabled?: boolean;
  name: string;
  status: SkinCorrIrritation[];
}


export class CreateProductModel {
  ProductName: string;
  ProductAlias: string;
  ProductCode: string;
  ManufacturerId: number;
  AdditionalSuppliers: string;
  LastVerified: string;
  RevisionDate: string;
  RegistrationNumber: string;
  SDSOrigin: any;
  ExemptionClass: any;
  SDSFormat: any;
  WHMISExempt: any;
  Discontinued: any;
  Pictogram: any;
  Notes: string;
  HazardCategoryId: any;
  HMISHealthRatings: any;
  HMISChronicRatings: any;
  HMISFlammabilityRatings: any;
  HMISReactivityRatings: any;
  NFPAHealthRatings: any;
  NFPAInstabilityRatings: any;
  NFPASpecificRatings: any;
  NFPAFlammabilityRatings: any;
  IARC: any;
  ACGIH: any;
  TransportHazardClass: any;
  PhysicalState: any;
  PhysicalHazardClass: any;
  HealthHazardClass: any;
  AcuteToxRoute: any;
  SkinIrrCorrRoute: any;
  FileName: string;
  LocationId: any;
}
